<template>
  <div data-test="app-error-status" class="app-error-status">
    <div v-if="!noImage" class="my-4">
      <img alt="error image" src="@/assets/error.png" />
    </div>
    <div class="info-title mb-2">{{ $t('error.title') }}</div>
    <div class="info-description mb-4">{{ $t('error.sub_title') }}</div>
    <v-btn
      v-if="!noButton"
      dark
      block
      @click="$emit('try-again')"
      class="mx-auto mt-0 mb-3"
      color="grey lighten-1"
    >{{ $t('error.try_again') }}</v-btn>
  </div>
</template>

<script>
export default {
  name: 'app-error-status',
  props: {
    noImage: {
      type: Boolean,
      default: false
    },
    noButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.app-error-status {
  padding: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  max-width: 300px;
  margin: 0 auto;
}
</style>
